//jshint esversion:8

import { isBDay } from "./ext/openDate.js";
import setPage from "./ext/setPage.js";
import { late, soon } from "./pages.js";
import { animate } from "./animation.js";

/******************************************************* SETUP ************************************************************/


const status = isBDay();
if (status === "IS_EARLY") setPage(soon);
if (status === "IS_LATE") setPage(late);
if (status === "ON_TIME") animate();